import * as types from "@/store/mutation-types";
import { DefineMutations } from "vuex-type-helper";
import {
  WatercraftTypeState,
  WatercraftTypeMutations,
  StateKeys,
  IWatercraftType
} from "./types";
import {
  GenericClearStore,
  GenericDeleteItem,
  GenericSetEdit,
  GenericSetEditField,
  GenericSetItem,
  GenericSetState,
  GenericSetStates
} from "@/store/helpers";
import { defaultState } from "./state";
import { watercraftTypeDefault } from "@/helpers/watercraftTypeDefault";

export const mutations: DefineMutations<
  WatercraftTypeMutations,
  WatercraftTypeState
> = {
  [types.SET_STATE]: GenericSetState<WatercraftTypeState, StateKeys>(),
  [types.SET_STATES]: GenericSetStates<WatercraftTypeState>(),
  [types.SET_EDIT]: GenericSetEdit<
    WatercraftTypeState,
    string | Partial<IWatercraftType>
  >("watercraftTypes", watercraftTypeDefault),
  [types.SET_EDIT_FIELD]: GenericSetEditField<
    WatercraftTypeState,
    keyof IWatercraftType
  >(),
  [types.SET_ITEM]: GenericSetItem<WatercraftTypeState, IWatercraftType>(
    "watercraftTypes",
    watercraftTypeDefault
  ),
  [types.DELETE_ITEM]: GenericDeleteItem<WatercraftTypeState>(
    "watercraftTypes",
    "_id"
  ),
  [types.CLEAR_WATERCRAFT_TYPE_STORE]: GenericClearStore<WatercraftTypeState>(
    defaultState()
  )
};
